/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ObjectionSource {
    Unknown = 0,
    UserSelect = 1,
    UserBespoke = 2,
    UserEdit = 3,
    AutoObjection = 4,
    Playbook = 5,
    PlaybookSearch = 6
}

export function ObjectionSourceFromJSON(json: any): ObjectionSource {
    return ObjectionSourceFromJSONTyped(json, false);
}

export function ObjectionSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObjectionSource {
    return json as ObjectionSource;
}

export function ObjectionSourceToJSON(value?: ObjectionSource | null): any {
    return value as any;
}

